import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/performance";
import "firebase/compat/messaging";
import "firebase/compat/analytics";
import axios from "axios";

const envConfig = (devValue, prodValue) => {
  if (process.env.REACT_APP_ENVIRONMENT === "DEVELOPMENT") return devValue;
  if (process.env.REACT_APP_ENVIRONMENT === "PRODUCTION") return prodValue;

  return devValue;
};

export const functionBaseUrl = envConfig(
  "https://us-central1-sportsbox-development.cloudfunctions.net",
  "https://us-central1-sportsbox-3dgolf.cloudfunctions.net",
);

export const websiteUrl = envConfig(
  "https://sportsbox-development.web.app",
  "https://3dgolf.sportsbox.ai",
);

export const firebaseConfig = envConfig(
  {
    apiKey: "AIzaSyDU9jCVJB4bFLQ5kK2B3eS-fWEdUKFxfWo",
    authDomain: "sportsbox-development.firebaseapp.com",
    projectId: "sportsbox-development",
    storageBucket: "sportsbox-development.appspot.com",
    messagingSenderId: "994120652577",
    appId: "1:994120652577:web:aa34b9cea0e40c17f61060",
    measurementId: "G-24EEBMEYZ2",
  },
  {
    apiKey: "AIzaSyB5V1vlPZrGE9BJ5qQQ2olSnBkne7B4u9I",
    authDomain: "sportsbox-3dgolf.firebaseapp.com",
    projectId: "sportsbox-3dgolf",
    storageBucket: "sportsbox-3dgolf.appspot.com",
    messagingSenderId: "249376958558",
    appId: "1:249376958558:web:c162108d4efb7a472daccf",
    measurementId: "G-M3DPV0E61S",
  },
);

export const storageBucketURL = envConfig(
  "https://console.firebase.google.com/u/0/project/sportsbox-development/storage/sportsbox-development.appspot.com/files/~2Fswing_data/",
  "https://console.firebase.google.com/u/0/project/sportsbox-3dgolf/storage/sportsbox-3dgolf.appspot.com/files/~2Fswing_data/",
);

export const esIndex = envConfig("docs", "docs-prod");

export const riIndex = envConfig("report_issues", "report_issues-prod");

export const stripeKey = envConfig(
  "pk_test_51JS3jaHK8QnjuqRNSlSVNOX9mD3Be02vIQZb2S5HHozM145GjpeVvuSHadBPcQSnJfHpZvPBnPmgHeFwXqjk7M5100Ez2ZTngL",
  "pk_live_51JS3jaHK8QnjuqRNKU8o7ZtGtUeF03nX0szre7AcvaiZYntkJrVweqbd12NNnSfkXonSTUFc33zAMhGNnr0PnHu400upbbHg6u",
);

export const loginWithGoogle = () => {
  let provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: "select_account",
  });
  return firebase.auth().signInWithPopup(provider);
};

export const loginWithFacebook = () => {
  const provider = new firebase.auth.FacebookAuthProvider();
  return firebase.auth().signInWithPopup(provider);
};

export const loginWithApple = () => {
  var provider = new firebase.auth.OAuthProvider("apple.com");
  return firebase.auth().signInWithPopup(provider);
};

export const axiosWithToken = async (url, options) => {
  const user = firebase.auth().currentUser;
  if (user) {
    const token = await user.getIdToken(true);
    return await axios(url, {
      ...options,
      withCredentials: false,
      headers: {
        authorization: "Bearer " + token,
      },
    });
  }

  const currentUser = localStorage.getItem("currUser");
  if (currentUser) {
    return await axios(url, {
      ...options,
      withCredentials: false,
      headers: {
        authorization: "Bearer " + currentUser,
      },
    });
  }
  throw new Error("User is not signed in");
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();
//firebase.performance();

export default firebase;
